__turbopack_context__.v({
  "className": "archivo_9bd14c04-module__pwZWhW__className",
  "variable": "archivo_9bd14c04-module__pwZWhW__variable",
});
